<script setup>
import { Toaster } from 'vue-sonner'
</script>

<template>
  <Toaster position="top-center" :rich-colors="true" :close-button="true" />
  <router-view />
</template>
